import { Router, NavigationEnd } from '@angular/router';
import { Component } from '@angular/core';
import { DipStateService } from './services/dip-state-service.service';
import { TogetherDIPStage } from './models/app.models';
import * as _ from 'lodash-es';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
  /**
   * Current routed URL.
   * @type {string}
   * @memberof TogetherHeaderComponent
   */
  current_url: string;


  /**
   * Creates an instance of TogetherHeaderComponent.
   * @param {Router} route
   * @memberof TogetherHeaderComponent
   */
  constructor(private route: Router, private state: DipStateService) {
    route.events.subscribe((url: any) => {
      this.current_url = url.url || '';
      /*
            if (url instanceof NavigationEnd) {
              this.trackPage(url.urlAfterRedirects);
            }
      */
    });
  }

  /*
    private trackPage(url: string): void {
      const trimmedPath = url.substring(1);
      const pathParts = trimmedPath.split('/');
      const stageRef = pathParts[1];
      const journeyType = pathParts[4] === 'true' ? 'Dip' : 'Application';

      let pageDescription = 'Unknown';

      const stage: TogetherDIPStage = _.find(this.state.allStages, (x: Object) => {
        const stage: TogetherDIPStage = x;
        if (stage.reference === stageRef) return stage;
      });

      if (stage) {
        pageDescription = stage.stageDescription;
      }

      if (stageRef !== 'tad_stage_login') {
        pageDescription = `${journeyType}/${pageDescription}`;
      }

      (<any>window).ga('set', 'page', pageDescription);
      (<any>window).ga('send', 'pageview');

  */
}
